import React, { useState } from "react"
import "./about.sass"
import { Slider, defaultIntl } from "../../utils"

// images
import Veges from "../../images/veges@2x.png"
import Sushi from "../../images/sushi@2x.png"
import FoodBoxs from "../../images/foodboxs@2x.png"
import FoodBox from "../../images/foodbox@2x.png"
import Shutter from "../../images/shutterstock@2x.png"
import Leaf from "../../images/leaf@2x.png"
import Leaf2 from "../../images/leaf@2x.png"
import Broccoli from "../../images/broccoli@2x.png"
import Tomato from "../../images/tomato@2x.png"

const getSliderList = intl => [
  <div className="columns is-mobile">
    {/* <!--美食外卖--> */}
    <div className="column text">
      <div className="text-content">
        <h2>{intl.formatMessage({ id: "index.about.a.title" })}</h2>
        <p>{intl.formatMessage({ id: "index.about.a.desc" })}</p>
      </div>
      <div className="leaf" style={{ left: "80%", top: "80%" }}>
        <img src={Tomato} alt="" />
      </div>
    </div>
    <div className="column img">
      <img src={FoodBoxs} alt="" className="foodboxs" />
    </div>
  </div>,
  <div className="columns is-mobile">
    {/* <!--美食自提--> */}
    <div className="column text">
      <div className="text-content">
        <h2>{intl.formatMessage({ id: "index.about.b.title" })}</h2>
        <p>{intl.formatMessage({ id: "index.about.b.desc" })}</p>
      </div>
      <div className="leaf">
        <img src={Broccoli} alt="" />
      </div>
    </div>
    <div className="column img">
      <img src={Shutter} alt="" />
    </div>
  </div>,
  <div className="columns is-mobile">
    {/* <!--饭团跑腿--> */}
    <div className="column text">
      <div className="text-content">
        <h2>{intl.formatMessage({ id: "index.about.c.title" })}</h2>
        <p>{intl.formatMessage({ id: "index.about.c.desc" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={FoodBox} alt="" className="foodbox" />
    </div>
  </div>,
  <div className="columns is-mobile">
    {/* <!--百货商城--> */}
    <div className="column text">
      <div className="text-content">
        <h2>{intl.formatMessage({ id: "index.about.d.title" })}</h2>
        <p>{intl.formatMessage({ id: "index.about.d.desc" })}</p>
      </div>
      <div className="leaf">
        <img src={Leaf2} alt="" />
      </div>
    </div>
    <div className="column img">
      <img src={Sushi} alt="" className="sushi" />
    </div>
  </div>,
  <div className="columns is-mobile">
    {/* <!--服务介绍--> */}
    <div className="column text">
      <div className="text-content">
        <h2>{intl.formatMessage({ id: "index.about.e.title" })}</h2>
        <p>{intl.formatMessage({ id: "index.about.e.desc" })}</p>
      </div>
      <div className="leaf">
        <img src={Leaf} alt="" />
      </div>
    </div>
    <div className="column img">
      <img src={Veges} alt="" className="vege" />
    </div>
  </div>,
]

const Mobile = ({ intl = defaultIntl }) => {
  return (
    <div className="about">
      {getSliderList(intl).map((slider, index) => {
        const klas = ["container"]
        if (index % 2 > 0) {
          klas.push("even")
        } else {
          klas.push("odd")
        }
        return (
          <div className={klas.join(" ")} key={index}>
            {slider}
          </div>
        )
      })}
    </div>
  )
}

export default ({ intl = defaultIntl }) => {
  const [slider, setSlider] = useState(null)
  const [current, setCurrent] = useState(0)
  const SliderList = getSliderList(intl)
  const SliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // fade: 1,
    afterChange: cur => {
      setCurrent(cur)
      if (cur === SliderList.length - 1) {
        setTimeout(() => {
          slider && slider.slickGoTo(0)
        }, 1500)
      }
    },
  }

  const handlerSwitch = i => {
    let item = document.querySelector(".current")
    if (item) {
      item.classList.remove("current")
    }
    slider.slickGoTo(i)
  }

  return (
    <div className="about">
      <Slider {...SliderSettings} ref={slider => setSlider(slider)}>
        {SliderList.map((slider, index) => {
          return (
            <div key={index} className="slide-item">
              <div className="container">{slider}</div>
            </div>
          )
        })}
      </Slider>
      <div className="container">
        <div className="slider-controll">
          {SliderList.map((s, i) => {
            const sliderClass = ["slider-indicator"]
            if (i === current) {
              sliderClass.push("current")
            }
            return <span className={sliderClass.join(" ")} onMouseOver={() => handlerSwitch(i)} key={i} />
          })}
        </div>
      </div>
    </div>
  )
}
